// src/components/Admin/Category/PricingRuleList.jsx
import React from 'react';
import PricingRuleItem from './PricingRuleItem';

export default function PricingRuleList({ rules, onEditRule, onDeleteRule, canEditRules, questionList }) {
    if (!rules || rules.length === 0) {
        return <p className="text-sm text-muted-foreground">No pricing rules defined for this category yet.</p>; // [cite: 1]
    }

    return (
        <div className="space-y-4"> {/* Increased spacing for better separation of cards */}
            {rules.map(rule => (
                <PricingRuleItem
                    key={rule.id}
                    rule={rule}
                    onEdit={onEditRule}
                    onDelete={onDeleteRule}
                    canEdit={canEditRules}
                    questionList={questionList} 
                />
            ))}
        </div>
    );
}